<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="container-fluid">
                <form id="FormEntrada" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <nav>
                                <div class="nav nav-tabs" id="nav-tab2" role="tablist">
                                    <button type="button" class="nav-link active" id="nav-elementos-tab" data-bs-toggle="tab" data-bs-target="#nav-elementos" role="tab" aria-controls="nav-elementos" aria-selected="false">
                                        Elementos del Evento
                                    </button>
                                    <button type="button" class="nav-link" id="nav-herramientas-tab" data-bs-toggle="tab" data-bs-target="#nav-herramientas" role="tab" aria-controls="nav-herramientas" aria-selected="false">
                                        Herramientas
                                    </button>
                                    <button type="button" class="nav-link" id="nav-insumos-tab" data-bs-toggle="tab" data-bs-target="#nav-insumos" role="tab" aria-controls="nav-insumos" aria-selected="false">
                                        Insumos
                                    </button>
                                </div>
                            </nav>

                            <div class="tab-content" id="nav-tabContent">
                                <div class="tab-pane fade show active pt-3" id="nav-elementos" role="tabpanel" aria-labelledby="nav-elementos-tab">
                                    <div class="table-responsive" v-for="(Arreglo,key,ind) in ObjEntradas.ElementosGaleria" :key="ind">
                                        <h5>{{ 'Evento '+Arreglo[ind].cotizacion_evento.Evento }}</h5>
                                        <table class="table align-items-center mb-0">
                                            <thead>
                                                <tr>
                                                    <th width="5%">#</th>
                                                    <th :class="StyleTh" width="5%">Seleccionar</th>
                                                    <th :class="StyleTh" width="20%">Nombre</th>
                                                    <th :class="StyleTh" width="10%">Cantidad de Salida</th>
                                                    <th :class="StyleTh" width="5%">Cant de:</th>
                                                    <th :class="StyleTh" width="15%">&nbsp;</th>
                                                    <th :class="StyleTh" width="15%">Observaciones Salida</th>
                                                    <th :class="StyleTh" width="25%">Observaciones Entrada</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item,index) in Arreglo" :key="index">
                                                    <td>
														{{(index+1)}}
													</td>
                                                    <td class="text-center">
                                                        <div class="form-check" v-show="item.CheckSalida==1">
                                                            <input type="checkbox" v-model="item.Check" @change="SeleccionConcepto(item)" :id="'chk'+index" class="form-check-input">
                                                            <label class="form-check-label" :for="'chk'+index">
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td style="width:30%">
                                                        <textarea v-model="item.Nombre" class="form-control" rows="4" readonly></textarea>
                                                    </td>
                                                    <td class="text-center">
                                                        <p :class="StyleTd">{{ item.CheckSalida==0 ? 'No Salió' : item.CantidadSalida }}</p>
                                                    </td>
                                                    <td>
                                                        <div class="form-group row">
                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-2">
                                                                <label for="Entrada">Entrada</label>
                                                            </div>
                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-2">
                                                                <label for="Daniada">Dañada</label>
                                                            </div>
                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-2">
                                                                <label for="Perdida">Perdida</label>
                                                            </div>
                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                <label for="Destruida">Destruida</label>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="form-group row">
                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                                                                <input :disabled="!item.Check" type="text" v-model="item.CantidadRetorno" @input="$onlyNums($event,item,'CantidadRetorno');CalculaStock($event, item, 'CantidadRetorno')" class="form-control">
                                                            </div>

                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                                                                <input :disabled="!item.Check" type="text" v-model="item.CantidadDaniada" @input="$onlyNums($event,item,'CantidadDaniada');CalculaStock($event, item, 'CantidadDaniada')" class="form-control">
                                                            </div>

                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                                                                <input :disabled="!item.Check" type="text" v-model="item.CantidadPerdida" @input="$onlyNums($event,item,'CantidadPerdida');CalculaStock($event, item, 'CantidadPerdida')" class="form-control">
                                                            </div>

                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                <input :disabled="!item.Check" type="text" v-model="item.CantidadDestruida" @input="$onlyNums($event,item,'CantidadDestruida');CalculaStock($event, item, 'CantidadDestruida')" class="form-control">
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <textarea disabled name="" id="" cols="30" rows="4" v-model="item.ComentarioSalida" class="form-control"></textarea>
                                                    </td>
                                                    <td>
                                                        <textarea name="" id="" cols="30" rows="4" v-model="item.ComentarioEntrada" class="form-control"></textarea>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div class="tab-pane fade show" id="nav-herramientas" role="tabpanel" aria-labelledby="nav-herramientas-tab">
                                    <div class="table-responsive">
                                        <table class="table align-items-center mb-0">
                                            <thead>
                                                <tr>
                                                    <th width="5%">#</th>
                                                    <th :class="StyleTh" width="5%">Seleccionar</th>
                                                    <th :class="StyleTh" width="20%">Nombre</th>
                                                    <th :class="StyleTh" width="10%">Cantidad de Salida</th>
                                                    <th :class="StyleTh" width="5%">Cant de:</th>
                                                    <th :class="StyleTh" width="15%">&nbsp;</th>
                                                    <th :class="StyleTh" width="15%">Observaciones Salida</th>
                                                    <th :class="StyleTh" width="25%">Observaciones Entrada</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item,index) in ObjEntradas.Herramientas" :key="index">
                                                    <td>
														{{(index+1)}}
													</td>
                                                    <td class="text-center">
                                                        <div class="form-check" v-show="item.CheckSalida==1">
                                                            <input type="checkbox" v-model="item.Check" @change="SeleccionConcepto(item)" :id="'chkH'+index" class="form-check-input">
                                                            <label class="form-check-label" :for="'chkH'+index">
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td style="width:30%">
                                                        <h6 :class="StylePr">{{ item.Nombre }}</h6>
                                                    </td>
                                                    <td class="text-center"><p :class="StyleTd">{{ item.CheckSalida==0 ? 'No Salió' : item.CantidadSalida }}</p></td>
                                                    <td>
                                                        <div class="form-group row">
                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-2">
                                                                <label for="Entrada">Entrada</label>
                                                            </div>
                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-2">
                                                                <label for="Daniada">Dañada</label>
                                                            </div>
                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-2">
                                                                <label for="Perdida">Perdida</label>
                                                            </div>
                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                <label for="Destruida">Destruida</label>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="form-group row">
                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                                                                <input :disabled="!item.Check" type="text" v-model="item.CantidadRetorno" @input="$onlyNums($event,item,'CantidadRetorno');CalculaStock($event, item, 'CantidadRetorno')" class="form-control">
                                                            </div>

                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                                                                <input :disabled="!item.Check" type="text" v-model="item.CantidadDaniada" @input="$onlyNums($event,item,'CantidadDaniada');CalculaStock($event, item, 'CantidadDaniada')" class="form-control">
                                                            </div>

                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                                                                <input :disabled="!item.Check" type="text" v-model="item.CantidadPerdida" @input="$onlyNums($event,item,'CantidadPerdida');CalculaStock($event, item, 'CantidadPerdida')" class="form-control">
                                                            </div>

                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                <input :disabled="!item.Check" type="text" v-model="item.CantidadDestruida" @input="$onlyNums($event,item,'CantidadDestruida');CalculaStock($event, item, 'CantidadDestruida')" class="form-control">
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td><textarea disabled name="" id="" cols="30" rows="4" v-model="item.ComentarioSalida" class="form-control"></textarea></td>
                                                    <td><textarea name="" id="" cols="30" rows="4" v-model="item.ComentarioEntrada" class="form-control"></textarea></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div class="tab-pane fade show" id="nav-insumos" role="tabpanel" aria-labelledby="nav-insumos-tab">
                                    <div class="table-responsive">
                                        <table class="table align-items-center mb-0">
                                            <thead>
                                                <tr>
                                                    <th width="5%">#</th>
                                                    <th :class="StyleTh" width="5%">Seleccionar</th>
                                                    <th :class="StyleTh" width="20%">Nombre</th>
                                                    <th :class="StyleTh" width="10%">Cantidad de Salida</th>
                                                    <th :class="StyleTh" width="5%">Cant de:</th>
                                                    <th :class="StyleTh" width="15%">&nbsp;</th>
                                                    <th :class="StyleTh" width="15%">Observaciones Salida</th>
                                                    <th :class="StyleTh" width="25%">Observaciones Entrada</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item,index) in ObjEntradas.Insumos" :key="index">
                                                    <td>
														{{(index+1)}}
													</td>
                                                    <td class="text-center">
                                                        <div class="form-check" v-show="item.CheckSalida==1">
                                                            <input type="checkbox" v-model="item.Check" @change="SeleccionConcepto(item)" :id="'chkI'+index" class="form-check-input">
                                                            <label class="form-check-label" :for="'chkI'+index">
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td style="width:30%">
                                                        <h6 :class="StylePr">{{ item.Nombre }}</h6>
                                                    </td>
                                                    <td class="text-center">
                                                        <p :class="StyleTd">{{ item.CheckSalida==0 ? 'No Salió' : item.CantidadSalida }}</p>
                                                    </td>
                                                    <td>
                                                        <div class="form-group row">
                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-2">
                                                                <label for="Entrada">Entrada</label>
                                                            </div>
                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-2">
                                                                <label for="Daniada">Dañada</label>
                                                            </div>
                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-2">
                                                                <label for="Perdida">Perdida</label>
                                                            </div>
                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                <label for="Destruida">Destruida</label>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="form-group row">
                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                                                                <input :disabled="!item.Check" type="text" v-model="item.CantidadRetorno" @input="$onlyNums($event,item,'CantidadRetorno');CalculaStock($event, item, 'CantidadRetorno')" class="form-control">
                                                            </div>

                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                                                                <input :disabled="!item.Check" type="text" v-model="item.CantidadDaniada" @input="$onlyNums($event,item,'CantidadDaniada');CalculaStock($event, item, 'CantidadDaniada')" class="form-control">
                                                            </div>

                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                                                                <input :disabled="!item.Check" type="text" v-model="item.CantidadPerdida" @input="$onlyNums($event,item,'CantidadPerdida');CalculaStock($event, item, 'CantidadPerdida')" class="form-control">
                                                            </div>

                                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                <input :disabled="!item.Check" type="text" v-model="item.CantidadDestruida" @input="$onlyNums($event,item,'CantidadDestruida');CalculaStock($event, item, 'CantidadDestruida')" class="form-control">
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td><textarea disabled name="" id="" cols="30" rows="4" v-model="item.ComentarioSalida" class="form-control"></textarea></td>
                                                    <td><textarea name="" id="" cols="30" rows="4" v-model="item.ComentarioEntrada" class="form-control"></textarea></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <br>
                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-10 col-lg-10">
                        </div>
                        <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                            <label for="TipoGuardado">Forma de Guardar:</label>
                            <select v-model="TipoGuardado" id="TipoGuardado" class="form-select">
                                <option value="Temporal">Temporal</option>
                                <option value="Definitivo">Definitivo</option>
                            </select>
                        </div>
                    </div>
                </form>
            </div>
        </template>
    </CLoader>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
export default {
    name:'Entradas',
    props:['poBtnSave'],
    data() {
        return {
            ConfigLoad:{
                ShowLoader: false,
                ClassLoad: false,
            },
            ObjEntradas:{
                ElementosGaleria:[],
                Herramientas:[],
                Insumos:[]
            },
            ObjEvento:{},
            ObjSolicitudAlmacen:{},
            ListaCheckHerramientas:[],
            ListaCheckInsumos:[],
            ListaCheckGaleria:[],
            Emit: this.poBtnSave.EmitSeccion,
            errorvalidacion: [],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            TipoGuardado: 'Temporal'
        }
    },
    methods: {
        async Guardar()
        {
            let band1 = 0;
            let msg1 = '';
            let band2 = 0;
            let msg2 = '';
            let band3 = 0;
            let msg3 = '';
            

            // SI EL TIPO DE GUARDADO ES DEFINITIVO ENTONCES REALIZAMOS TODAS LAS VALIDACIONES
            if(this.TipoGuardado == 'Definitivo')
            {
                // VALIDAMOS QUE CADA RETORNO CON INCIDENCIAS TENGA SU COMENTARIO RESPECTIVO
                // console.log(this.ObjEntradas.ElementosGaleria);
                let fila = 1; // Nuestro contador real de filas de la tabla HTML

                $.each(this.ObjEntradas.ElementosGaleria, function(idEvento, arregloArticulos) {
                    
                    for (let i = 0; i < arregloArticulos.length; i++)
                    {
                        let item = arregloArticulos[i];
                        let ComentarioVacio = !item.ComentarioEntrada || 
                        String(item.ComentarioEntrada).trim() === '' || 
                        String(item.ComentarioEntrada).trim().toLowerCase() === 'null';
                        // let NombreCorto = item.Nombre.length > 15 ? item.Nombre.substring(0, 15) + '...' : item.Nombre;
                        
                        if (item.CheckEntrada != 1) {
                            msg1 = "Elementos: La partida: " + fila + " aun no ha sido marcada para su retorno";
                            band1++;
                            return false; // Rompe el for
                        } 
                        else if ((item.CantidadRetorno < item.CantidadSalida) && ComentarioVacio && item.CheckSalida > 0) {
                            msg1 = "Elementos: El campo observaciones de entrada de la partida: " + fila + " no puede estar vacio";
                            band1++;
                            return false; // Rompe el for
                        }

                        fila++; // Incrementamos la fila por cada artículo procesado
                    }
                });

                if(band1>0){ this.$toast.warning(msg1); return false; }


                $.each(this.ObjEntradas.Herramientas, function(key, value){
                    let ComentarioVacio = !value.ComentarioEntrada || 
                        String(value.ComentarioEntrada).trim() === '' || 
                        String(value.ComentarioEntrada).trim().toLowerCase() === 'null';
                        
                    if(value.CheckEntrada != 1){
                        msg2 = "Herramientas: La partida: "+(key+1)+" aun no ha sido marcada para su retorno";
                        band2++;
                        return false;
                    }
                    else if ((value.CantidadRetorno < value.CantidadSalida) && ComentarioVacio && value.CheckSalida > 0) {
                        msg2 = "Herramientas: El campo observaciones de entrada de la partida: "+(key+1)+" no puede estar vacio";
                        band2++;
                        return false;
                    }
                });
                if(band2>0){ this.$toast.warning(msg2); return false; }

                $.each(this.ObjEntradas.Insumos, function(key, value){
                    let ComentarioVacio = !value.ComentarioEntrada || 
                        String(value.ComentarioEntrada).trim() === '' || 
                        String(value.ComentarioEntrada).trim().toLowerCase() === 'null';

                    if(value.CheckEntrada != 1){
                        msg3 = "Insumos: La partida: "+(key+1)+" aun no ha sido marcada para su retorno";
                        band3++;
                        return false;
                    }
                    else if ((value.CantidadRetorno < value.CantidadSalida) && ComentarioVacio && value.CheckSalida > 0) {
                        msg3 = "Isumos: El campo observaciones de entrada de la partida: "+(key+1)+" no puede estar vacio";
                        band3++;
                        return false;
                    }
                });
                if(band3>0){ this.$toast.warning(msg3); return false; }

                // DESPUES VALIDAMOS QUE LAS CANTIDADES DE RETORNO COINCIDAN CON LAS DE SALIDA
                if (!this.ValidarCantidadesRetorno(this.ObjEntradas.ElementosGaleria)) {
                    return false;
                }
                if (!this.ValidarCantidadesRetorno(this.ObjEntradas.Herramientas)) {
                    return false;
                }
                if (!this.ValidarCantidadesRetorno(this.ObjEntradas.Insumos)) {
                    return false;
                }
            }

            let ElementosGaleria=[];
            for (const [Index,Elementos] of Object.entries(this.ObjEntradas.ElementosGaleria)) {
                Elementos.forEach(Elemento => {
                    ElementosGaleria.push(Elemento);
                });
            }

            let formData = new FormData();
            formData.set("ElementosGaleria",JSON.stringify(ElementosGaleria));
            formData.set("Herramientas",JSON.stringify(this.ObjEntradas.Herramientas));
            formData.set("Insumos",JSON.stringify(this.ObjEntradas.Insumos));
            formData.set("Estatus",'EnTransito');
            formData.set('TipoGuardado',this.TipoGuardado);

            await this.$http.post(
                'marcarEntradaAlmacen/'+this.ObjSolicitudAlmacen.IdMovimientoAlmacen,formData
            ).then((res)=>{
                this.EjecutaConExito(res);
            }).catch((err)=>{
                this.EjecutaConError(err);
            })
        },
        ValidarCantidadesRetorno(ArregloObjeto)
        {
            let BndError = false;
            let Mensaje = "";

            // 1. Normalizamos la información: 
            // Si viene el objeto agrupado (Galería), extraemos todos los artículos en un solo array plano.
            // Si ya es un array (Herramientas/Insumos), lo dejamos tal cual.
            let listaPlana = [];
            
            if (Array.isArray(ArregloObjeto)) {
                listaPlana = ArregloObjeto;
            } else {
                // Es el objeto agrupado de Galería. Unimos todos sus arreglos internos.
                Object.keys(ArregloObjeto).forEach(idEvento => {
                    listaPlana = listaPlana.concat(ArregloObjeto[idEvento]);
                });
            }

            // Recorremos todos los artículos segun el que mandemos
            listaPlana.every((item) => {
                // Convertimos a número cada campo, asegurando un 0 si está vacío o nulo
                let Salida      = parseInt(item.CantidadSalida) || 0;
                let Retorno     = parseInt(item.CantidadRetorno) || 0;
                let Daniada     = parseInt(item.CantidadDaniada) || 0;
                let Perdida     = parseInt(item.CantidadPerdida) || 0;
                let Destruida   = parseInt(item.CantidadDestruida) || 0;

                // Sumamos los 4 campos de entrada
                let TotalEntrada = Retorno + Daniada + Perdida + Destruida;

                // Validación 1: Que la suma no exceda la salida
                if (TotalEntrada < Salida)
                {
                    let NombreCorto = item.Nombre.length > 15 ? item.Nombre.substring(0, 15) + '...' : item.Nombre;

                    Mensaje = `En el artículo "${NombreCorto}", la suma de la cantidad de ingresos (${TotalEntrada}) no coincide con la cantidad que salió originalmente (${Salida}).`;
                    BndError = true;
                    return false; // Rompe el ciclo 'every'
                }

                return true; // Continúa el ciclo
            });

            // Si hubo error, disparamos el toast y frenamos el guardado
            if (BndError) {
                this.$toast.warning(Mensaje);
                return false;
            }

            return true; // Todo en orden
        },
        EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            if(this.TipoGuardado == 'Definitivo')
            {
                this.bus.$emit('CloseModal_'+this.Emit);
                this.bus.$emit('List_seccionSolicitudAlmacen');
            }
        },
        EjecutaConError(err)
        {
            // this.objHerramienta.Stock=this.objHerramienta.Cantidad;
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Recuperar()
        {
            this.$http.get('marcarSalidaAlmacen',{
                params:{
                    IdCotizacion: this.ObjEvento.IdCotizacion,
                    IdMovimientoAlmacen: this.ObjEvento.IdMovimientoAlmacen
                    // SalidaCheck:1
                }
            }).then((res)=>{
                this.ObjSolicitudAlmacen = res.data.data.MovimientoAlmacen;
                // this.ObjEntradas.ElementosGaleria = res.data.data.DetallesCotizacion;

                this.ObjEntradas.ElementosGaleria = res.data.data.DetallesCotizacion.reduce((Resultado,Elemento)=>{
                    (Resultado[Elemento.IdCotizacionEvento] = Resultado[Elemento.IdCotizacionEvento] || []).push(Elemento);
                    return Resultado;
                },{});
                
                this.ObjEntradas.Herramientas = res.data.data.Herramientas;
                this.ObjEntradas.Insumos = res.data.data.Insumos;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            })
        },
        Limpiar(){

        },
        SeleccionConcepto(item)
        {
            if (item.Check) {
                item.CheckEntrada = 1;
            }
            else{
                item.CheckEntrada = 0;
            }
        },
        CalculaStock(event, item, campo)
		{
            // Convertimos a número cada campo, asegurando un 0 si está vacío o nulo
            let Salida      = parseInt(item.CantidadSalida) || 0;
            let Retorno     = parseInt(item.CantidadRetorno) || 0;
            let Daniada     = parseInt(item.CantidadDaniada) || 0;
            let Perdida     = parseInt(item.CantidadPerdida) || 0;
            let Destruida   = parseInt(item.CantidadDestruida) || 0;

            // Sumamos los 4 campos de entrada
            let TotalEntrada = Retorno + Daniada + Perdida + Destruida;

            if (TotalEntrada > Salida)
            {
                var valor = event.target;
                valor.value = '';
                item[campo] = '';
            }
		},
    },
    created() {
        this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id,Obj)=>{
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;
            this.ObjEvento = Obj;

            this.Recuperar();
            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>{
                this.Guardar();
            });
        });
    },
}
</script>

<style>

</style>